import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";
import { configureLookupManagement } from "../../../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName as machineLookupManagementServiceName,
  vsLookupManagementServiceProviderName as machineLookupManagementServiceProviderName,
} from "../../../shared/lookups";

import { moduleName as recordsModuleName } from "../../../../records";

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

const module = angular
  .module(vsModuleName, [recordsModuleName])

  .config(machineManufacturerLookupConfig);

configureLookupManagement(module, {
  baseStateSref: "main.machines.lookups",
  lookupManagementServiceName: machineLookupManagementServiceName,
  lookupManagementServiceProviderName:
    machineLookupManagementServiceProviderName,
  defaultModifyPermission: "machineLookupModify",
});
